import { createFileRoute } from "@tanstack/react-router";
import FeynmanAIGuide from "@/pages/resources/FeynmanAIGuide";

export const Route = createFileRoute("/learn/feynman-ai")({
  head: () => ({
    meta: [
        {
            "title": "Feynman Technique + AI: How to Apply It to Your Courses | System Atlas"
        },
        {
            "name": "description",
            "content": "Combine the Feynman technique with AI tools to learn faster. A practical guide to applying teach-to-learn with AI assistance on your own course materials."
        },
        {
            "property": "og:title",
            "content": "Feynman Technique + AI: How to Apply It to Your Courses | System Atlas"
        },
        {
            "property": "og:description",
            "content": "Combine the Feynman technique with AI tools to learn faster. A practical guide to applying teach-to-learn with AI assistance on your own course materials."
        },
        {
            "property": "og:type",
            "content": "article"
        },
        {
            "property": "og:url",
            "content": "https://systematlas.fr/learn/feynman-ai"
        },
        {
            "property": "og:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        },
        {
            "name": "twitter:card",
            "content": "summary_large_image"
        },
        {
            "name": "twitter:title",
            "content": "Feynman Technique + AI: How to Apply It to Your Courses | System Atlas"
        },
        {
            "name": "twitter:description",
            "content": "Combine the Feynman technique with AI tools to learn faster. A practical guide to applying teach-to-learn with AI assistance on your own course materials."
        },
        {
            "name": "twitter:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        }
    ],
    links: [
        {
            "rel": "canonical",
            "href": "https://systematlas.fr/learn/feynman-ai"
        },
        {
            "rel": "alternate",
            "hrefLang": "en",
            "href": "https://systematlas.fr/learn/feynman-ai"
        },
        {
            "rel": "alternate",
            "hrefLang": "fr",
            "href": "https://systematlas.fr/fr/learn/feynman-ai"
        },
        {
            "rel": "alternate",
            "hrefLang": "x-default",
            "href": "https://systematlas.fr/learn/feynman-ai"
        }
    ],
  }),
  component: FeynmanAIGuide,
});
